import { compose, withState } from "recompose";

import Button from "../CustomButton/CustomButton";
import { FormattedMessage } from "react-intl";
import React from "react";
import _ from "lodash";


class SendButton extends React.Component {
  constructor(props) {
    super();

    this.state = {
      // used to register working state during the debounce delay only
      workInProgressLocal: false
    };
  }

  // onMouseDown = value => {
  //   // enabled only if parent workInProgress false
  //   !!!this.props.workInProgress &&
  //     this.props.onMouseDown &&
  //     this.props.onMouseDown(value);
  //   !!!this.props.workInProgress &&
  //     this.props.onClick &&
  //     this.props.onClick(value);
  //   this.setState({ workInProgressLocal: false });
  // };

  onClick = value => {
    !!!this.props.workInProgress &&
      this.props.onClick &&
      this.props.onClick(value);
    this.setState({ workInProgressLocal: false });
  };

  // debouncedonMouseDown = _.debounce(this.onMouseDown, 20);
  debouncedonClick = _.debounce(this.onClick, 100);

  render = () => {
    return (
      <Button
        {...this.props}
               
        onClick={value => {
          this.setState({ workInProgressLocal: true });
          //this.onClick(value);
          this.debouncedonClick(value);
        }}
        disabled={
          this.props.disabled ||
          this.props.workInProgress ||
          this.state.workInProgressLocal
        }
        icon
        wd
        fill
        bsStyle="primary"
      >
        {this.props.workInProgress || this.state.workInProgressLocal ? (
          <i className="fa fa-lg fa-spinner fa-spin margin-right-5" />
        ) : (
          <i className="fa fa-lg fa-envelope margin-right-5" />
        )}
        <FormattedMessage id="ids_send" />
      </Button>
    );
  };
}

export { SendButton };